// const root = `http://localhost:5200`                        //local
const root = `https://api.signmate.io`                      //beta
// const root = `https://esignatureapi.pitangent.in`          //staging

export default class Configs {
    public static API_ROOT: string = root
    public static API_URL: string = `${root}/api/v1`
}